import { NgModule } from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import { BroadcastLayerComponent } from './broadcast-layer/broadcast-layer.component';
import { StatusComponent } from './broadcast-layer/status/status.component';
import { BatterComponent } from './broadcast-layer/batter/batter.component';
import { BoxScoreComponent } from './broadcast-layer/box-score/box-score.component';
import { LineupComponent } from './broadcast-layer/lineup/lineup.component';
import { DefenseComponent } from './broadcast-layer/defense/defense.component';
import { PitcherComponent } from './broadcast-layer/pitcher/pitcher.component';
import { FollowedGamesComponent } from './broadcast-layer/followed-games/followed-games.component';
import {MatGridListModule} from "@angular/material/grid-list";
import {MatIconModule} from "@angular/material/icon";
import { PossitionPlayerComponent } from './broadcast-layer/defense/possition-player/possition-player.component';
import { IntroComponent } from './broadcast-layer/intro/intro.component';
import { LowerThirdComponent } from './broadcast-layer/lower-third/lower-third.component';
import { PowerByComponent } from './broadcast-layer/power-by/power-by.component';
import { CustomTableComponent } from './broadcast-layer/custom-table/custom-table.component';
import { UserOutputComponent } from './user-output/user-output.component';
import { PartnerLogosComponent } from './broadcast-layer/partner-logos/partner-logos.component';



@NgModule({
  declarations: [
    BroadcastLayerComponent,
  ],
  imports: [
    CommonModule,
    MatGridListModule,
    MatIconModule,
    StatusComponent,
    FollowedGamesComponent,
    BoxScoreComponent,
    LineupComponent,
    LowerThirdComponent,
    CustomTableComponent,
    PitcherComponent,
    PowerByComponent,
    DefenseComponent,
    PossitionPlayerComponent,
    IntroComponent,
    BatterComponent,
    PartnerLogosComponent,
  ],
  providers: [
    DecimalPipe,
  ],
  exports: [
      BroadcastLayerComponent,
      StatusComponent,
      LowerThirdComponent,
      PitcherComponent,
      BoxScoreComponent,
      CustomTableComponent,
      LineupComponent,
      FollowedGamesComponent,
  ],
})
export class BroadcastLayerModule { }
